import { Link } from "react-router-dom";
import { news } from "@/mocks/news";
import { stars } from "@/mocks/stars";
import NewsCard from "@/components/feature/NewsCard";

const latestNews = news.slice(0, 4);
const hotStars = stars.slice(0, 6);

export default function StarHighlights() {
  return (
    <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
      <div className="lg:col-span-2">
        <div className="mb-5 flex items-end justify-between gap-4">
          <div>
            <div className="mb-2 flex items-center gap-2">
              <span className="h-1 w-6 rounded-full bg-accent-500" />
              <span className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">Star &amp; News</span>
            </div>
            <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl">明星动态精选</h2>
          </div>
          <Link
            to="/news"
            className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700 sm:inline-flex"
          >
            更多动态
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 gap-4">
          {latestNews.map((item) => (
            <NewsCard key={item.id} item={item} layout="horizontal" />
          ))}
        </div>
      </div>

      <div>
        <div className="mb-5">
          <div className="mb-2 flex items-center gap-2">
            <span className="h-1 w-6 rounded-full bg-primary-500" />
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">Faces</span>
          </div>
          <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl">人气明星</h2>
        </div>
        <div className="grid grid-cols-3 gap-3">
          {hotStars.map((star) => (
            <Link key={star.id} to={`/stars/${star.id}`} className="group block">
              <div className="relative w-full overflow-hidden rounded-lg" style={{ aspectRatio: "1 / 1" }}>
                <img
                  src={star.avatar}
                  alt={`${star.name} 形象照`}
                  title={`${star.name} - 朝桐光明星资讯`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <p className="mt-2 truncate text-center text-sm font-medium text-foreground-800 transition-colors group-hover:text-primary-700">
                {star.name}
              </p>
            </Link>
          ))}
        </div>
        <Link
          to="/stars"
          className="mt-5 inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
        >
          查看全部明星
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </div>
  );
}